// packages/web/src/api/workorders/query-options.ts
import { queryOptions } from "@tanstack/react-query";
import { workordersList, workorderCranesList } from "../generated/sdk.gen.ts";
import type { WorkordersListData } from "../generated/types.gen.ts";
import { queryKeys } from "../query-keys.ts";
import { workordersKeys } from "./keys.ts";

type ListParams = NonNullable<WorkordersListData["query"]>;

export const workordersListOptions = (params: ListParams) =>
  queryOptions({
    queryKey: queryKeys.workorders.list(params),
    queryFn: async () => {
      const { data, error } = await workordersList({ query: params });
      if (error) throw error;
      return data;
    },
  });

export function workorderSearchOptions(q: string) {
  return queryOptions({
    queryKey: workordersKeys.search(q),
    queryFn: async () => {
      const { data, error } = await workordersList({
        query: { q: q || undefined, limit: 20 },
      });
      if (error) throw error;
      if (!data) throw new Error("Workorder search failed");
      return data.data;
    },
    staleTime: 60_000,
  });
}

export function craneByWorkorderOptions(workorderId: string) {
  return queryOptions({
    queryKey: workordersKeys.cranesByWorkorder(workorderId),
    queryFn: async () => {
      const { data, error } = await workorderCranesList({ path: { workorderId } });
      if (error) throw error;
      if (!data) throw new Error("Cranes by workorder failed");
      return data.data;
    },
    staleTime: 60_000,
  });
}
